module.exports = __webpack_public_path__ + "img/電気回路_1_4_4.6a403e62.png";